import React from "react";
import PropTypes from "prop-types";

const SocialLinks = ({
  links = [
    {
      faClass: "fa fa-facebook-official",
      name: "facebook",
      url: "https://www.facebook.com/TomoCredit-759847904399856/",
    },
    {
      faClass: "fa fa-twitter",
      name: "twitter",
      url: "https://twitter.com/tomocredit?lang=en",
    },
    {
      faClass: "fa fa-linkedin",
      name: "linkedin",
      url: "https://www.linkedin.com/company/tomocredit",
    },
    {
      faClass: "fa fa-instagram",
      name: "instagram",
      url: "https://www.instagram.com/tomocredit/",
    },
  ],
  style = {},
  anchorStyle = {},
  className = "",
  anchorClassName = "",
  boost = false,
}) => {
  return (
    <div className={`text-2xl ${className}`} style={style}>
      {links.map((l) => {
        return (
          <a
            className={`${boost ? "hover:text-boost-purple-alt" : "hover-primary"} px-2 pt-2 ${anchorClassName}`}
            style={anchorStyle}
            href={l.url}
            key={l.name}
            onClick={() => {
              // window.analytics.track("LANDING_SOCIAL_SHARE_CLICKED", {
              //   social: l.name,
              // });
            }}
          >
            <i className={l.faClass} aria-hidden="true" />
          </a>
        );
      })}
    </div>
  );
};

SocialLinks.propTypes = {
  links: PropTypes.array,
  style: PropTypes.object,
  anchorStyle: PropTypes.object,
  className: PropTypes.string,
  anchorClassName: PropTypes.string,
};

export default SocialLinks;
